module.exports = __webpack_public_path__ + "static/media/gun-largel.40034d64.jpg";